import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { hasPermission } from "../utils/permissions";
import "../styles/AdminEMIRequests.css";

function AdminEMIRequests() {
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState("");

  const canView = hasPermission("emi", "view");

  useEffect(() => {
    if (!canView) return;

    fetch("https://kolibusiness.com/backend/get-emi-requests.php")
      .then((res) => res.json())
      .then((data) => setRequests(data))
      .catch((err) => {
        console.error("❌ Error fetching EMI requests:", err);
        setError("Failed to fetch EMI requests. Please try again later.");
      });
  }, [canView]);

  if (!canView) {
    return (
      <AdminLayout>
        <p className="error-message">❌ You do not have permission to view EMI requests.</p>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="emi-container">
        <h2>📄 EMI Requests</h2>

        {error && <p className="error-message">{error}</p>}

        <div className="table-wrapper">
          <table className="emi-table">
            <thead>
              <tr>
                <th>EMI ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Bank</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Submitted</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.length > 0 ? (
                requests.map((r) => (
                  <tr key={r.uniq_id}>
                    <td>{r.uniq_id}</td>
                    <td>{r.name}</td>
                    <td>{r.phone}</td>
                    <td>{r.bank_name}</td>
                    <td>₹{r.amount}</td>
                    <td>{r.status || "Pending"}</td>
                    <td>{r.created_at}</td>
                    <td>
                      <Link to={`/admin/emi-request/${r.uniq_id}`} className="view-btn">
                        👁 View
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="no-data">No EMI requests found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminEMIRequests;
